export const SIZES = {
  MEDIUM: 'medium',
  SMALL: 'small'
};
export const TYPES = {
  TEXT: 'text',
  SEARCH: 'search',
  PASSWORD: 'password',
  NUMBER: 'number',
  DATE: 'date',
  EMAIL: 'email',
  URL: 'url'
};